<template>
  <div class="studies-table">
    <div class="checkboxes-container">
      <span class="studies-table-title">
        <h3>Filter table by study type</h3>
        <input
          type="checkbox"
          id="filter-all-checkbox"
          value="filter-all"
          @click="toggleAllFilters"
          checked
        />
        <label for="filter-all-checkbox" id="filter-all-label">Clear all</label>
      </span>
      <ul class="studies-filters" style="margin-bottom: 10px;">
        <li v-for="(item, index) in deDupedValues" :key="index">
          <input
            class="studies-checkbox"
            type="checkbox"
            :id="item"
            :value="item"
            @click="filterStudyTypes"
            checked
          />
          <label :for="item" :key="index">{{ item }}</label>
        </li>
      </ul>
    </div>
    <md-table md-fixed-header v-model="filteredTableByStudy" class="table">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Reference">{{ item[0] }}</md-table-cell>
        <md-table-cell md-label="Link">
          <p style="font-size: 13px;" v-if="item[1] == ''">{{ item[1] }}</p>
          <a v-else :href="item[1]" rel="noopener noreferrer" target="_blank">{{
            item[1]
          }}</a>
        </md-table-cell>
        <md-table-cell md-label="Study Type">{{ item[2] }}</md-table-cell>
        <md-table-cell md-label="Open Access">{{ item[3] }}</md-table-cell>
        <md-table-cell md-label="Pollutant">{{ item[6] }}</md-table-cell>
        <md-table-cell md-label="Health Outcome">{{ item[7] }}</md-table-cell>
        <md-table-cell md-label="Study Summary">{{ item[8] }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "hei-studies-table",
  props: ["studies"],
  computed: {
    filteredTableByStudy() {
      let filteredDataByStudy = this.studies.filter((item) => {
        if (
          (this.$route.name == "Table" &&
            this.$route.params.state == "unmapped") ||
          (this.$route.name == "Table" && this.$route.params.state == "INDIA")
        ) {
          return item[11][0]
            .map((i) => {
              return this.globalCheckedValues.includes(i);
            })
            .some((b) => {
              return b;
            });
        } else {
          return item[11][0]
            .map((i) => {
              return this.globalCheckedValues.includes(i);
            })
            .some((b) => {
              return b;
            });
        }
      });
      return filteredDataByStudy;
    },

    deDupedValues() {
      // remove duplicates from original list of study types
      let deDuped = [...new Set(this.studies.map((v) => v[2]))];

      for (let i = 0; i < deDuped.length; i++) {
        if (
          deDuped[i] === undefined ||
          deDuped[i] === "" ||
          deDuped[i] === " "
        ) {
          deDuped[i] = "NA";
        } else {
          deDuped[i] = deDuped[i]
            .replace(/\n/gi, "")
            .trimStart()
            .trimEnd();
        }
        let studyVals = deDuped[i].split().map((d) => d);
        // find study values that contain a comma
        for (let s in studyVals) {
          if (studyVals[s].includes(",")) {
            let splitVals = studyVals[s].split(",").map((d) =>
              d
                .replace(/\n/gi, "")
                .trimStart()
                .trimEnd()
            );
            for (let j = 0; j < splitVals.length; j++) {
              let eachSplitVal = splitVals[j];
              deDuped.push(eachSplitVal);
            }
            // Remove values with commas
            const indexOfStudyVals = deDuped.indexOf(studyVals[s]);
            deDuped.splice(indexOfStudyVals, 1);
          }
        }
      }
      // TODO, for some reason finding and removing the commas has to be done twice
      for (let i = 0; i < deDuped.length; i++) {
        let studyVals = deDuped[i].split().map((d) => d);
        for (let s in studyVals) {
          if (studyVals[s].includes(",")) {
            let splitVals = studyVals[s].split(",").map((d) =>
              d
                .replace(/\n/gi, "")
                .trimStart()
                .trimEnd()
            );
            for (let j = 0; j < splitVals.length; j++) {
              let eachSplitVal = splitVals[j];
              deDuped.push(eachSplitVal);
            }
            // Remove values with commas
            const indexOfStudyVals = deDuped.indexOf(studyVals[s]);
            deDuped.splice(indexOfStudyVals, 1);
          }
        }
      }

      // DeDup again
      return [...new Set(deDuped.map((v) => v.replace(/\n/gi, "").trimEnd()))];
    },
    isUnmappedStudy() {
      return this.$route.params.state === "unmapped";
    },
    isNationalStudy() {
      return this.$route.params.state === "national";
    },
  },
  data: () => ({
    globalCheckedValues: [
      "Review***",
      "Epidemiology",
      "review",
      "Exposure Assessment",
      "Exposure assessment↵",
      "Exposure assessment",
      "Health Impact Assessment",
      "Health Impact Assessment ",
      "NA",
      "Editorial/Commentary",
      "Exposure assessment, Epidemiology, Review***",
      "Review, Exposure assessment",
      "Editorial/Commentary",
      "Review, Epidemiology",
      "Epidemiology, Review",
      "Exposure assessment, review",
      "Commentary",
      "Government report",
      "Exposure assessment, Health impact assessment",
      "Exposure Assessment, Health Impact Assessment",
      "Exposure assessment, Epidemiology",
      "Exposure Assessment, Epidemiology",
      "Exposure Assessment ",
    ],
    globalFilteredDataByStudies: [],
  }),
  methods: {
    filterStudyTypes() {
      let checkedValues = [];
      let checkboxes = document.querySelectorAll(".studies-checkbox:checked");
      checkboxes.forEach((checkbox) => checkedValues.push(checkbox.value));
      this.globalCheckedValues = checkedValues;
      if (checkboxes.length == 0) {
        document.getElementById("filter-all-checkbox").checked = false;
        document.getElementById("filter-all-label").innerHTML = "Select all";
      } else {
        document.getElementById("filter-all-checkbox").checked = true;
        document.getElementById("filter-all-label").innerHTML = "Clear all";
      }
    },
    toggleAllFilters(e) {
      const filterAllCheckbox = e.target;
      let checkedValues = [];
      let checkboxes = document.querySelectorAll(".studies-checkbox");
      if (filterAllCheckbox.checked) {
        document.getElementById("filter-all-label").innerHTML = "Clear all";
        for (var i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].type == "checkbox") {
            checkboxes[i].checked = true;
          }
          checkedValues.push(checkboxes[i].value);
        }
      } else {
        document.getElementById("filter-all-label").innerHTML = "Select all";
        for (var j = 0; j < checkboxes.length; j++) {
          if (checkboxes[j].type == "checkbox") {
            checkboxes[j].checked = false;
          }
        }
      }
      this.globalCheckedValues = checkedValues;
    },
  },
};
</script>

<style lang="scss">
.studies-table {
  position: relative;
  // overflow: auto;
  .studies-table-title {
    display: flex;
    align-items: center;
    h3 {
      margin-right: 5px;
    }
    input[type="checkbox"] {
      display: none;
    }

    input[type="checkbox"] + label {
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      border-radius: 50px;
      background-color: #fff;
      border: solid 1.5px mix(#fff, #092a38, 75%);
      padding: 0.25rem 0.5rem;
      margin: 2.5px;
      display: inline-block;
      -moz-user-select: -moz-none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      &:hover {
        background-color: mix(#fff, #092a38, 75%);
      }
    }
  }
}

.md-table .md-table-fixed-header {
  position: sticky;
  top: 0;
  z-index: 10000 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  .md-table-fixed-header-container {
    table {
      background-color: #fff !important;
      z-index: 0 !important;
    }
  }
}

.checkboxes-container {
  position: sticky !important;
  left: 0px !important;
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(50%);
  }
  100% {
    transform: translateY(0);
  }
}

.md-table {
  min-height: 50vh;
}
.studies-filters {
  display: flex;
  flex-flow: row wrap;
  margin: 0px;
  padding: 0px;
  li {
    list-style-type: none;
    input[type="checkbox"] {
      display: none;
    }

    input[type="checkbox"] + label {
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      border-radius: 50px;
      background-color: #fff;
      border: solid 1.5px mix(#fff, #7d7d7d, 75%);
      margin: 2.5px;
      display: inline-block;
      -moz-user-select: -moz-none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      padding: 5px 10px;
      &:hover {
        background-color: mix(#fff, #53a7da, 75%);
        border-color: mix(#fff, #53a7da, 75%);
      }
      &:before {
        content: "+ ";
        margin-right: 5px;
      }
    }

    input[type="checkbox"]:checked + label {
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
      background-color: #53a7da;
      color: white;
      border-color: #53a7da;
      &:hover {
        background-color: mix(#53a7da, black, 50%);
        border-color: mix(#53a7da, black, 50%);
      }
      &:before {
        content: "✓ ";
        margin-right: 5px;
      }
    }
  }
}

td.md-table-cell {
  text-align: left;
  max-width: 400px;
  min-width: 300px;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}
</style>
